/**
 * MapLoadingSkeleton — Loading placeholder for the Collateral Map.
 * [COLLATERAL MAP] Added 2026-07-14
 */

import React from "react";
import { Skeleton } from "./ui/skeleton";
import { MapPin } from "lucide-react";

interface MapLoadingSkeletonProps {
  height?: number;
}

export function MapLoadingSkeleton({ height = 400 }: MapLoadingSkeletonProps) {
  return (
    <div
      className="relative w-full rounded-lg overflow-hidden bg-gray-100 border border-gray-200"
      style={{ height }}
    >
      {/* Simulated map tiles */}
      <div className="absolute inset-0 grid grid-cols-4 grid-rows-4 gap-0.5 opacity-30">
        {Array.from({ length: 16 }).map((_, i) => (
          <Skeleton key={i} className="rounded-none h-full w-full" />
        ))}
      </div>

      {/* Center icon */}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
        <div className="bg-white rounded-full p-3 shadow-md">
          <MapPin className="h-6 w-6 text-blue-600 animate-pulse" />
        </div>
        <span className="text-sm text-gray-600 bg-white/80 px-3 py-1 rounded-full">
          ກຳລັງໂຫຼດແຜນທີ່...
        </span>
      </div>

      {/* Simulated zoom controls */}
      <div className="absolute top-3 right-3 flex flex-col gap-1">
        <Skeleton className="h-8 w-8 rounded" />
        <Skeleton className="h-8 w-8 rounded" />
      </div>
    </div>
  );
}
